import { Pipe, PipeTransform } from '@angular/core';

import { normalizeText } from '../utils/text.utils';

@Pipe({
    name: 'search',
    standalone: false
})
export class SearchPipe implements PipeTransform {

  transform(items: any[], searchText: string, searchedProperty?: string): any[] {

    if (!items) return [];
    if (!searchText) return items;
    searchText = normalizeText(searchText);
    return items.filter((it) => {

      if (searchedProperty) {
        if (it.collection?.length) {

          let parentFolderMatch;
          if (searchText.includes('/')) {
            parentFolderMatch = normalizeText(it.collection.join('/')).includes(searchText);
          } else {
            parentFolderMatch = it.collection.find(folder => normalizeText(folder).includes(searchText));
          }

          return it[searchedProperty] && normalizeText(it[searchedProperty]).includes(searchText)
            || parentFolderMatch;
        }
        else return it[searchedProperty] && normalizeText(it[searchedProperty]).includes(searchText);
      } else {
        return normalizeText(it).includes(searchText);
      }

    });

  }
}
